import { useState, useEffect } from "react"
import { Checkbox } from "primereact/checkbox";
import { InputText } from "primereact/inputtext"
import '../styles/components/text-filter.scss'

const TextFilter = ({setTextFilter}) => {
    const [caseSensitive, setCaseSensitive] = useState(false);
    const [textValue, setTextValue] = useState('');

    useEffect(() => {
        if (!textValue.length) {
            setTextFilter(/.+/g);
        } else {
            setTextFilter(caseSensitive ? new RegExp(textValue, 'g') : new RegExp(textValue, 'gi'));
        }
    }, [textValue, caseSensitive])
    
    return (
        <div className="filterbox">
            {/* <label>Filter by Strain Name</label> */}
            <InputText className='filtertext' value={textValue} onChange={e => setTextValue(e.target.value)}/>
            <span className="case-check">
                <label htmlFor="case-sensitive">Case-sensitive</label>
                <Checkbox inputId="case-sensitive" onChange={(e) => setCaseSensitive(e.checked)} checked={caseSensitive}/>
            </span>
        </div>
    )
}

export default TextFilter;